

const List = () => {

    const availableProps = {
      
          'color':{
            defaultVals:['#ff55f8'],
            label:'Text Color'
          },
          'background-color':{
            defaultVals:['#ff55f8'],
            label:'Bg Color'
          },
          'opacity':{
            defaultVals:['.3'],
            label:'Opacity',
          },
      
         
          'width':{
            defaultVals:['100vw','50vw','200vw'],
            label:'Width'
          },
          'custom-css':{
            defaultVals:['','',''],
            label:'Custom CSS'
          },
          'fontSize':{
            defaultVals:['10px','50px','20px'],
            label:'Font Size'
          },
          'bgSize':{
            defaultVals:['100% 100%','120% 120%','100% 100%'],
            label:'Bg Size'
          },
          'bgPosition':{
            defaultVals:['0% 0%','50% 50%','100% 100%'],
            label:'Bg Position'
          },
          'translateX':{
            defaultVals:['100px','0px','-100px'],
            label:'Move X',
          },
          'translateY':{
            defaultVals:['100px','0px','-100px'],
            label:'Move Y'
          },
          'perspective':{
            defaultVals:['100px','300px','200px'],
            label:'Perspective'
          },
          'letterSpacing':{
            defaultVals:['20px','0px','50px'],
            label:'Letter Spacing'
          },
          'scale':{
            defaultVals:['100%','150%','100%'],
            label:'Scale'
          },
          'boxShadow':{
            defaultVals:['0 0 5px 0 rgba(0,0,0,.2)','0 0 10px 0 rgba(0,0,0,.2)','0 0 20px 0 rgba(0,0,0,.2)'],
            label:'Box Shadow'
          },
          'blur':{
            defaultVals:['10px','0px','10px'],
            label:'Blur'
          },
          'rotateX':{
            defaultVals:['180deg','0deg','-180deg'],
            label:'Rotate X'
          },
          'rotateY':{
            defaultVals:['180deg','0deg','-180deg'],
            label:'Rotate Y'
          },
          'rotateZ':{
            defaultVals:['180deg','0deg','-180deg'],
            label:'Rotate Z'
          },
          'skewX':{
            defaultVals:['0deg','20deg','0deg'],
            label:'Skew X'
          },
          'skewY':{
            defaultVals:['0deg','20deg','0deg'],
            label:'Skew Y'
          },
          'backgroundColor':{
            defaultVals:['#738bff','#73FFEB','#F64FFF'],
            label:'Bg Color'
          },
          'textColor':{
            defaultVals:['#738bff','#73FFEB','#F64FFF'],
            label:'Text Color'
          }
        
      }
    const listProps = () => {
        let ret = []
        for (let prop in availableProps){
            if (!ret.find(k=>k.label === availableProps[prop].label)) ret.push({prop:prop,...availableProps[prop]})
        }
        ret.sort( (a, b) => (a.label < b.label) ? -1 : (a.label > b.label) ? 1 : 0)
        
        return ret.map((r,i)=><div className='block lg:inline-block ' key={r.prop}>
            <div className={'propChip-'+i+' py-3 px-6 text-indigo-400 bg-indigo-50 rounded-3xl items-center gap-3 m-2 flex lg:inline-flex'}>
            <div className='w-2 h-2 bg-indigo-400 rounded-xl'></div>{r.label}</div></div>)
    }

    return <section className='overflow-hidden'>
        <div className='container mx-auto p-10 lg:p-20'>
            <div className='flex flex-col lg:flex-row gap-10 items-center'>
                <div className='lg:w-1/3'>
                    <h3>Animate a huge variety of CSS properties</h3>
                    <p>With Animator you can tween a wide list of CSS properties to achieve cool scroll animation effects.</p>
                </div>
                <div className='flex-1 text-sm font-mono font-bold'>
                    {listProps()}
                    
                    <div className='propChip-20 text-slate-300 py-3 px-6 inline-flex items-center gap-2'>
                    <div className='w-2 h-2 bg-slate-300 rounded-xl'></div>And more...</div>
                </div>
                
            </div>
        </div>
    </section>
}

export default List